import axios from 'axios';
import { ApiConfig } from '../constants/apiConfig';

export const ajukanIzin = async ({ fotoFile, keterangan, jenisIzin, tanggalIzin }) => {
  try {
    const token = localStorage.getItem('student_token');
    if (!token) throw new Error('Sesi login berakhir. Silakan login kembali.');

    const formData = new FormData();
    formData.append('status', 'menunggu');
    formData.append('jenis_izin', jenisIzin);
    formData.append('tanggal_izin', tanggalIzin);
    formData.append('persetujuan', '1');
    formData.append('keterangan', keterangan);
    formData.append('foto', fotoFile);

    const response = await axios.post(`${ApiConfig.baseUrl}/absensi`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      },
    });

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    console.error('Error ajukan izin:', error);
    const rawMessage = error.response?.data?.message || error.message || 'Gagal mengirim izin';
    const message = typeof rawMessage === 'string'
      ? rawMessage
      : Object.values(rawMessage).flat().filter(Boolean).join(' ');
    return {
      success: false,
      message,
    };
  }
};
